export default __webpack_public_path__ + "static/media/exclamation-circle.b437b8a5.svg";